import { Box, Grid, Tooltip, Typography, styled } from "@mui/material";
import { BoxTypeMap } from "@mui/system";
import React from "react";
import { Defined, IControl } from "sonobello.utilities.react";

import INoteTag from "../Types/INoteTag";

export const classNames = {
  noteTagLabel: "NoteTagsDisplay_tag-label",
  defaultTagsOnlyLabel: "NoteTagsDisplay_default-tags-only-label"
};

/** A list of the provided note tags which have a configured label. */
const NoteTagsDisplay: React.FC<IControl<INoteTag[]>> = ({ value }) => {
  const tagsWithLabels = value.filter(v => v.label) as Defined<INoteTag>[];
  return (
    <Grid container spacing={1}>
      {tagsWithLabels.length ? (
        tagsWithLabels.map(({ label, value }, index) => (
          <Grid item key={index}>
            <NoteTagComponent title={label} key={index} value={value} />
          </Grid>
        ))
      ) : (
        <Grid item>
          <Typography className={classNames.defaultTagsOnlyLabel} variant="body2" sx={{ opacity: 0.5 }}>
            Default note tags only...
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

interface NoteTagProps {
  title: string;
  value: string;
}

const NoteTagBox = styled(Box)<Partial<BoxTypeMap>>(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "white",
  borderRadius: "5px",
  padding: "1px 5px",
  cursor: "default"
}));

const NoteTagComponent: React.FC<NoteTagProps> = ({ title, value }) => (
  <Tooltip title={value}>
    <NoteTagBox component="span" borderRadius="5px" className={classNames.noteTagLabel}>
      <Typography variant="caption">{title}</Typography>
    </NoteTagBox>
  </Tooltip>
);

export default NoteTagsDisplay;
